import { pageSeo } from "@/config/seo";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { Hero } from "@/components/home/Hero";
import { ProductCategoryStrip } from "@/components/home/ProductCategoryStrip";
import { InfrastructureIntro } from "@/components/home/InfrastructureIntro";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { SolutionSelector } from "@/components/home/SolutionSelector";
import { ArchitectureShowcase } from "@/components/home/ArchitectureShowcase";
import { UseCases } from "@/components/home/UseCases";
import { EmailFeature } from "@/components/home/EmailFeature";
import { PurchaseProcess } from "@/components/home/PurchaseProcess";
import { FAQSection } from "@/components/home/FAQSection";
import { FinalCTA } from "@/components/home/FinalCTA";

const seo = pageSeo(
  "VPS, Dedicated Servers, Cloud & Business Email",
  "Explore VPS hosting, dedicated servers, cloud infrastructure, business email and security solutions from The Planet."
);

export function HomePage() {
  useDocumentMeta(seo.title, seo.description);

  return (
    <>
      <Hero />
      <ProductCategoryStrip />
      <InfrastructureIntro />
      <ServicesGrid />
      <WhyChooseUs />
      <SolutionSelector />
      <ArchitectureShowcase />
      <UseCases />
      <EmailFeature />
      <PurchaseProcess />
      <FAQSection />
      <FinalCTA />
    </>
  );
}
